import 'babel-polyfill';
import 'core-js/fn/object/assign';
import React from 'react';
import { Route, IndexRoute, Router, browserHistory } from 'react-router';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import configureStore from './stores/configureStore';
import '../node_modules/toastr/build/toastr.css';
import '../node_modules/react-widgets/lib/scss/react-widgets.scss';
import AdminApp from './components/Main';
import RankApp from './components/RankMain';
import Error from './components/Error';
import Login from './components/login/LoginPage';
import ProfileAdmin from './components/profile/ProfileAdmin';
import ProfileStudent from './components/profile/ProfileStudent';
import RunPage from './components/runs/RunPage';
import ClassesPage from './components/classes/ClassesPage';
import ClassPageContainer from './components/classes/ClassPageContainer';
import StudentsPage from './components/students/StudentsPage';
import StudentPageContainer from './components/students/StudentPageContainer';
import GroupsPage from './components/groups/GroupsPage';
import GroupPage from './components/groups/GroupPage';
import ResetPasswordPage from './components/login/ResetPasswordPage';

import StudentLoginPage from './components/login/StudentLoginPage';
import GetStartedPage from './components/rank/GetStartedPage';
import FindClassesPage from './components/rank/FindClassesPage';
import StudentFindClassesPage from './components/rank/StudentFindClassesPage';
import RankClassesPage from './components/rank/RankClassesPage';
import ViewSchedulesPage from './components/rank/ViewSchedulesPage';
import DashboardPage from './components/runs/DashboardPage';
import PublishAssignmentPage from './components/runs/PublishAssignmentPage';
import StudentManageWaitlistsPage from './components/rank/StudentManageWaitlistsPage';
import SudentJoinWaitlistPage from './components/rank/StudentJoinWaitlistPage';
import ConfirmPage from './components/rank/ConfirmPage';

const store = configureStore();

function requireAdmin(nextState, replace) {
  const storage = sessionStorage.getItem('auth') ? sessionStorage : localStorage;
  let role = storage.getItem('r');
  let token = storage.getItem('auth');
  let run = storage.getItem('run');
  if (role == 1 || (!token && (role == 0 || !role))) {
    sessionStorage.clear();
    localStorage.clear();
    replace(`/administer/${run}/login`);
  }
  return;
}

function requireStudent(nextState, replace) {
  const storage = sessionStorage.getItem('auth') ? sessionStorage : localStorage;
  let role = storage.getItem('r');
  let token = storage.getItem('auth');
  let run = storage.getItem('run');
  if (role == 0 || (!token && (role == 1 || !role))) {
    sessionStorage.clear();
    localStorage.clear();
    replace(`/rank/${run}/login`);
  }
  return;
}

// Get the runName from the URL
const runName = window.location.pathname.split('/')[2];

// Store the runName in localStorage
localStorage.setItem('run', runName);
sessionStorage.setItem('run', runName);

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <Route path="/administer/:runName" component={AdminApp}>
        <IndexRoute component={Login} />
        <Route path="login" component={Login} />
        <Route path="assignment" component={RunPage} onEnter={requireAdmin} />
        <Route path="assignment/publish" component={PublishAssignmentPage} onEnter={requireAdmin} />
        <Route path="assignment/dashboard(/:computationId)" component={DashboardPage} onEnter={requireAdmin} />
        <Route path="profile" component={ProfileAdmin} onEnter={requireAdmin} />
        <Route path="classes" component={ClassesPage} onEnter={requireAdmin} />
        <Route path="class(/:id)" component={ClassPageContainer} onEnter={requireAdmin} />
        <Route path="students" component={StudentsPage} onEnter={requireAdmin} />
        <Route path="student(/:id)" component={StudentPageContainer} onEnter={requireAdmin} />
        <Route path="groups" component={GroupsPage} onEnter={requireAdmin} />
        <Route path="group(/:id)" component={GroupPage} onEnter={requireAdmin} />
      </Route>
      <Route path="/rank/:runName" component={RankApp}>
        <IndexRoute component={StudentLoginPage} />
        <Route path="login" component={StudentLoginPage} />
        <Route path="start" component={GetStartedPage} onEnter={requireStudent} />
        <Route path="schedule" component={GetStartedPage} onEnter={requireStudent} />
        <Route path="profile" component={ProfileStudent} onEnter={requireStudent} />
        <Route path="find-classes" component={StudentFindClassesPage} onEnter={requireStudent} />
        <Route path="join-waitlist/:id" component={SudentJoinWaitlistPage} onEnter={requireStudent} />
        <Route path="find" component={FindClassesPage} onEnter={requireStudent} />
        <Route path="rank" component={RankClassesPage} onEnter={requireStudent} />
        <Route path="schedules" component={ViewSchedulesPage} onEnter={requireStudent} />
        <Route path="manage-waitlists" component={StudentManageWaitlistsPage} onEnter={requireStudent} />
        <Route path="confirm" component={ConfirmPage} onEnter={requireStudent} />
      </Route>
      <Route path="/reset-password" component={ResetPasswordPage} />
      <Route path="*" component={Error} />
    </Router>
  </Provider>,
  document.getElementById('app')
);



// WEBPACK FOOTER //
// ./src/index.js